module.exports = __webpack_public_path__ + "static/img/1.1b0abde.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/6/sp/1.png
// module id = uAns
// module chunks = 0